<template>
	<div>
		<topNavigation
			:deleteSort="[4]"
			:addEndRightMenuList="[
				{ name: '产品介绍', toLink: '/productIntroduce' },
				{
					name: '使用指南',
					toLink: 'http://www.drcnet.com.cn/bayWindow/ProjectMV?title=思政信息资源平台&url=https://misc.drcnet.com.cn/help/iap/iap-guide.mp4',
				},
			]"
			:databaseDefalut="false"
		>
			<template v-slot:nav-top-content-isMobile-bottom>
				<homeNavIsMoblie
					v-if="!isCustomRoute"
					style="width: 310px"
				></homeNavIsMoblie>
				<homeNavIsMoblieCustom
					v-else
					style="width: 310px"
				></homeNavIsMoblieCustom>
			</template>
		</topNavigation>
		<TopBanner
			v-if="!isCustomRoute"
			contentWidth="1200"
			height="113"
			versionName="[思政信息资源平台]"
			versionNameVerticalAlign="26"
			versionNameShow="1"
			versionNameColor="#ce342d"
			versionNameFontSize="24"
			styleApi="padding-top"
			logoMargin="28"
			headerBackgroundImg="none"
			headerContentBackgroundImg="none"
		>
			<template slot="topBannerContent">
				<Search
					class="add"
					searchPosition="1"
					selectType="1,3,0"
					keyWordsInputTab="请输入关键词"
					searchUrl="0,50360"
					heighSearchUrl="2,50360"
					searchBoxWidth="638,0"
					searchInputWidth="295,0"
					inputAndSelectWrapWidth="371,0"
					simpleSearchIcon="https://images.drcnet-sod.com/Images/Common/search_a.jpg"
					simpleSearchButton="30,50,#9c7c7d,20,12"
					heighSearchButton="30,50,#ff5237,15,12"
				>
					<template v-slot:aiBtn>
						<!-- 你想要放的自定义按钮 -->
						<a
							@click="searchGoAi()"
							target="blank"
							class="searchbtnb aibtnb"
							>AI检索</a
						>
					</template>
				</Search>
			</template>
		</TopBanner>
		<TopBanner
			class="custom-style"
			v-if="isCustomRoute"
			contentWidth="1200"
			height="113"
			versionName="广西自然资源职业技术学院"
			versionNameVerticalAlign="26"
			versionNameShow="1"
			versionNameColor="#ce342d"
			versionNameFontSize="24"
			styleApi="padding-top"
			logoMargin="28"
			headerBackgroundImg="none"
			headerContentBackgroundImg="none"
		>
			<template slot="subtitle">
				<span style="font-size: 16px">专供</span>
			</template>
			<template slot="topBannerContent">
				<Search
					class="add"
					searchPosition="1"
					selectType="1,3,0"
					keyWordsInputTab="请输入关键词"
					searchUrl="0,50360"
					heighSearchUrl="2,50360"
					searchBoxWidth="525,0"
					searchInputWidth="295,0"
					inputAndSelectWrapWidth="370,0"
					simpleSearchIcon="https://images.drcnet-sod.com/Images/Common/search_a.jpg"
					simpleSearchButton="30,50,#9c7c7d,20,12"
					heighSearchButton="30,50,#ff5237,15,12"
				>
				</Search>
			</template>
		</TopBanner>
		<!-- <homeNav v-if="isMoblie == false"></homeNav>
		  -->
		<homeNav v-if="!isCustomRoute && !isMoblie" />
		<homeNavCustom v-if="isCustomRoute && !isMoblie" />
		<!-- <Search class="homeSearch" searchPosition="1"></Search> -->
		<appMain></appMain>
		<footers></footers>
	</div>
</template>
<script>
import topNavigation from '@/components/topNavigation.vue';
import TopBanner from '@/components/TopBanner';
import appMain from './components/appMain.vue';
import homeNav from './components/homeNav.vue';
import homeNavCustom from './components/homeNavCustom.vue';
import homeNavIsMoblie from './components/homeNavIsMoblie.vue';
import homeNavIsMoblieCustom from './components/homeNavIsMoblieCustom.vue';
import footers from './components/footer.vue';
import Search from '@/components/Search';
import { mapMutations } from 'vuex';
import { getNav } from '../api/home';
export default {
	name: '',
	components: {
		topNavigation,
		TopBanner,
		homeNav,
		footers,
		appMain,
		Search,
		homeNavIsMoblie,
		homeNavCustom,
		homeNavIsMoblieCustom,
	},
	mixins: [],
	props: {},
	data() {
		return {
			assemblyList: [],
			isMoblie: false,
		};
	},
	computed: {
		// 判断当前路由是否为 /custom
		isCustomRoute() {
			console.log(this.$route.name === 'custom');

			return this.$route.name === 'custom';
		},
	},
	watch: {
		MobileVerification: {
			handler(to) {
				// console.log(to);
				this.isMoblie = this.MobileVerification;
				// this.isMobileVt();
				// this.isMobileValue();
			},
			immediate: true,
		},
	},
	created() {},
	mounted() {
		//因为移动端需要在首页获取重点专题库的内容  但是在打开抽屉之前第调用不到导航接口  所以只能在组件入口发放接口内容.
		if (this.isMoblie == true) {
			let _this = this;
			getNav({ uid: 'A7', depth: '0' }).then((res) => {
				_this.updateHomeNavList(res.data.data);
			});
		}
	},
	methods: {
		...mapMutations(['updateHomeNavList']),
		searchGoAi() {
			window.open('https://search.drcnet.com.cn/aiSearch'); // 弹出一个新页面
		},
	},
	beforeDestroy() {
		//组件销毁前要解绑事件
		this.$eventBus.$off('bustype1');
		this.$eventBus.$off('literatureList');
		this.$eventBus.$off('upLists');
	},
};
</script>
<style lang="less" scoped>
.add {
	position: absolute;
	right: 0;
	top: 60px;
}
::v-deep .searchbox {
	.aibtnb {
		line-height: 30px;
		background: #e6a23c;
		padding: 0px 20px;
		height: 30px;
		font-size: 12px;
		margin-left: 1px;
	}
}
@media screen and (max-width: 769px) {
	.add {
		position: absolute;
		right: 0;
		top: 176px !important;
		bottom: 0px !important;
		display: flex;
	}

	.header {
		height: 192px !important;

		.header-content {
			display: block !important;

			.header-logo {
				display: block !important;

				img {
					display: block !important;
				}
			}
		}
	}
	::v-deep .header .header-content .header-logo {
		display: block !important;
		text-align: center;
	}
	::v-deep .header .header-content .header-logo .version-name {
		display: block !important;
	}
	::v-deep .header .header-content .header-logo img {
		display: block !important;
		margin: 0 auto;
		margin-bottom: 8px;
	}
}
</style>
